import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'app-set-awv-email-template',
  templateUrl: './set-awv-email-template.component.html',
  styleUrls: ['./set-awv-email-template.component.scss'],
})
export class SetAwvEmailTemplateComponent implements OnInit {
  formGroup: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<SetAwvEmailTemplateComponent>,
    private snackService: SnackService,
    private clientsService: ClientsService
  ) {}

  ngOnInit(): void {
    this.formGroup = new UntypedFormGroup({
      option: new UntypedFormControl(this.data.client?.awv_setup?.isDefault ? 'default' : 'custom'),
      template_id: new UntypedFormControl(
        !this.data.client?.awv_setup?.isDefault ? this.data.client?.awv_setup?.email_template : ''
      ),
    });
  }

  saveTemplateId(): void {
    const templateId =
      this.formGroup.value.option === 'custom'
        ? this.formGroup.value.template_id
        : 'd-52da4f36e9d44b86b7e5dc35ba32a035';

    const emailTemplate = {
      email_template: templateId,
      isDefault: this.formGroup.value.option === 'default',
    };

    this.clientsService
      .saveAWVEmailTemplate(this.data.client.client_id, emailTemplate)
      .then(() => {
        this.snackService.genericSnackBar('AWV email template saved successfully!', ['success-snackbar'], 5000);
        this.dialogRef.close();
      })
      .catch((error) => {
        this.snackService.genericSnackBar('AWV email template not saved!', ['warn-snackbar'], 5000);
        this.dialogRef.close();
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  get disabledButton(): boolean {
    return this.formGroup.value.option === 'custom' && this.formGroup.value.template_id === '';
  }
}
